var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _g, _path24, _path25, _path26, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAttendance(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 86,
    height: 98,
    viewBox: "0 0 86 98",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3152_310)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_3152_310",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 86,
    height: 98
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3 9.5H86",
    stroke: "black",
    strokeWidth: 3
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.5 8V95",
    stroke: "black",
    strokeWidth: 3
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M84.5 11V78",
    stroke: "black",
    strokeWidth: 3
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M0 96.5H86",
    stroke: "black",
    strokeWidth: 3
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M84.5 86V98",
    stroke: "black",
    strokeWidth: 3
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M0 24.5H13",
    stroke: "black",
    strokeWidth: 3
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M21 24.5H84",
    stroke: "black",
    strokeWidth: 3
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M13 66.5H31",
    stroke: "black",
    strokeWidth: 3
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M13 84.5H31",
    stroke: "black",
    strokeWidth: 3
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5 86V65",
    stroke: "black",
    strokeWidth: 3
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M31.5 86V65",
    stroke: "black",
    strokeWidth: 3
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M13 37.5H31",
    stroke: "black",
    strokeWidth: 3
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M13 55.5H31",
    stroke: "black",
    strokeWidth: 3
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5 57V36",
    stroke: "black",
    strokeWidth: 3
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M31.5 57V36",
    stroke: "black",
    strokeWidth: 3
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M41 46.5H70",
    stroke: "black",
    strokeWidth: 3
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M41 75.5H72",
    stroke: "black",
    strokeWidth: 3
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M42.5 75.9995L42.5057 44.9995",
    stroke: "black",
    strokeWidth: 3
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M72.5 77V57",
    stroke: "black",
    strokeWidth: 3
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M24.5 4.5C24.5 2.84315 23.1569 1.5 21.5 1.5C19.8431 1.5 18.5 2.84315 18.5 4.5V15.5C18.5 17.1569 19.8431 18.5 21.5 18.5C23.1569 18.5 24.5 17.1569 24.5 15.5V4.5Z",
    fill: "#D9D9D9",
    stroke: "black",
    strokeWidth: 3
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M44.5 4.5C44.5 2.84315 43.1569 1.5 41.5 1.5C39.8431 1.5 38.5 2.84315 38.5 4.5V15.5C38.5 17.1569 39.8431 18.5 41.5 18.5C43.1569 18.5 44.5 17.1569 44.5 15.5V4.5Z",
    fill: "#D9D9D9",
    stroke: "black",
    strokeWidth: 3
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M65.5 4.5C65.5 2.84315 64.1569 1.5 62.5 1.5C60.8431 1.5 59.5 2.84315 59.5 4.5V15.5C59.5 17.1569 60.8431 18.5 62.5 18.5C64.1569 18.5 65.5 17.1569 65.5 15.5V4.5Z",
    fill: "#D9D9D9",
    stroke: "black",
    strokeWidth: 3
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M46.9136 57.0881C47.4989 56.5028 48.4596 56.5439 48.9927 57.177L54.6184 63.8576C55.3659 64.7452 56.7095 64.8125 57.5418 64.0039L71.9342 50.0227C72.7102 49.2689 73.9951 49.487 74.4788 50.4546C74.7902 51.0773 74.6629 51.8299 74.1641 52.3155L57.5499 68.4926C56.7148 69.3056 55.3643 69.2353 54.6182 68.34L46.8273 58.991C46.3597 58.4298 46.3971 57.6046 46.9136 57.0881Z",
    fill: "black"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_3152_310)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M86 0H0V98H86V0Z",
    fill: "#172B4D"
  }))), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M22 5H21C20.4477 5 20 5.44772 20 6V14C20 14.5523 20.4477 15 21 15H22C22.5523 15 23 14.5523 23 14V6C23 5.44772 22.5523 5 22 5Z",
    fill: "#172B4D"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M42 5H41C40.4477 5 40 5.44772 40 6V14C40 14.5523 40.4477 15 41 15H42C42.5523 15 43 14.5523 43 14V6C43 5.44772 42.5523 5 42 5Z",
    fill: "#172B4D"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M63 5H62C61.4477 5 61 5.44772 61 6V14C61 14.5523 61.4477 15 62 15H63C63.5523 15 64 14.5523 64 14V6C64 5.44772 63.5523 5 63 5Z",
    fill: "#172B4D"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3152_310"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 86,
    height: 98,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAttendance);
export default __webpack_public_path__ + "static/media/attendance.17273f1e9d7d432b7f21f4097d8f315b.svg";
export { ForwardRef as ReactComponent };